export default __webpack_public_path__ + "static/retreat_0-a15c8657a5ec4e35b8179c8d3820c0a1.jpg";